import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { CurrencyCode } from '../../types/API'
import {
  IAddToBasket,
  IGiftItemResponse,
  IColorTheme,
  GiftItemStatus,
  GiftItemType,
} from '../../types/itemTypes'
import Item from '../../item/Item'
import { getItemColorTheme } from '../../helpers/itemHelper'
import { Font } from '../../types/organisation'

const Styles = styled.div`
  width: inherit;
  max-width: 1068px;
  margin: auto;
  padding: 25px;
  @media (max-width: 320px) {
    padding: 25px 5px 5px;
  }
  background-color: ${(props): string => props.theme.colourPageBackground};
`

const Grid = styled.div`
  display: grid;
  ${({ theme: { items } }): string => {
    // Limit width when we have fewer than 4 items so no room for empty columns
    if (items === 3) return 'max-width: 800px; margin: auto;'
    if (items === 2) return 'max-width: 520px; margin: auto;'
    if (items === 1) return 'max-width: 300px; margin: auto;'
    return ''
  }};
  grid-template-columns: repeat(auto-fill, minmax(237px, 1fr));
  grid-gap: 40px;
`

const Message = styled.div`
  text-align: center;
  font-weight: bold;
  margin: 50px;
  color: ${(props): string => props.theme.colourTextOnBackground};
`
interface IItemGridProps extends IAddToBasket {
  giftItems: IGiftItemResponse[]
  currency: CurrencyCode
  organisationColors?: Partial<IColorTheme>
  font?: Font
  compact?: boolean
}
function ItemGrid({
  giftItems,
  currency,
  organisationColors,
  addToBasket,
  font,
  compact,
}: IItemGridProps): ReactElement {
  const colors = getItemColorTheme(organisationColors)

  const items = giftItems.filter((item) => {
    const isPublished = item.status === GiftItemStatus.Published
    const isComplimentary = item.type === GiftItemType.Complimentary
    return isPublished || isComplimentary
  })

  const grid = items.map((item, index) => {
    const key = `${item.id}-${index}`
    return (
      <Item
        key={key}
        giftItem={item}
        currency={currency}
        addToBasket={addToBasket}
        organisationColors={organisationColors}
        font={font}
        compact={compact}
      />
    )
  })

  return (
    <Styles theme={colors}>
      {items.length ? (
        <Grid theme={{ items: items.length }}>{grid}</Grid>
      ) : (
        <Message theme={colors}>No items found, check back later.</Message>
      )}
    </Styles>
  )
}
export default ItemGrid
